export const AP_CHROMATOGRAPHY_CALCULATORS_LOADER = {
  desktop: `
<div class="cui cui-grid cui-container">
    <div class="cui-skeleton-paragraph -spacing--bottom-40 -spacing--top-40">
        <div class="cui-skeleton-paragraph__content" style="width: 188px;">
          <div class="cui-skeleton__item" style="height: 16px;"></div>
        </div>
    </div>
    <div class="cui-skeleton-heading -size--large -spacing--top-40 -spacing--bottom-20 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: 74%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--top-40">
        <div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--top-40">
        <div class="cui-skeleton__item" style="width: 74%; height: 18px;"></div>
    </div>
    <div class="cui cui-grid cui-container -spacing--top-24">
        <div class="cui-row">
            <div class="cui-col-lg-4">
                <div class="cui-skeleton-rectangle -is--block">
                    <div class="cui-skeleton__item" style="width: 300px; height: 40px;"></div>
                </div>
                <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
                    <div class="cui-skeleton__item" style="width: 64px; height: 14px;"></div>
                </div>
                <div class="cui-skeleton-rectangle -is--block -spacing--top-8">
                    <div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div>
                </div>
                <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
                    <div class="cui-skeleton__item" style="width: 64px; height: 14px;"></div>
                </div>
                <div class="cui-skeleton-rectangle -is--block -spacing--top-8">
                    <div class="cui-skeleton__item" style="width: 100%; height: 48px;"></div>
                </div>
                <div class="cui-skeleton-rectangle -is--block -spacing--top-32 -spacing--bottom-40">
                    <div class="cui-skeleton__item -spacing--right-24" style="width: 120px; height: 48px;"></div>
                    <div class="cui-skeleton__item" style="width: 120px; height: 48px;"></div>
                </div>
            </div>
            <div class="cui-col-lg-5">
                <div class="cui-skeleton-rectangle -is--block">
                    <div class="cui-skeleton__item" style="width: 300px; height: 40px;"></div>
                </div>
                <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
                    <div class="cui-skeleton__item" style="width: 100%; height: 248px;"></div>
                </div>
            </div>
        </div>
    </div>
    <div style="margin-top: 80px;">
    <div class="cui-skeleton-heading -size--medium -spacing--bottom-40 -resolution--desktop">
      <div class="cui-skeleton-heading__content" style="width: 100%;">
        <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 36px;"></div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4 -spacing--bottom-24">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 400px;"></div>
        </div>
      </div>
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4 -spacing--bottom-24">
        <div class="cui-skeleton-heading -size--medium -resolution--desktop">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 400px;"></div>
          </div>
        </div>
      </div>
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4 -spacing--bottom-24">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 400px;"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
